export const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const teen = (integer: number): boolean => integer > 10 && integer < 20;

const suffix = (input: number): string => {
  const integer = Math.abs(input);
  if (teen(integer % 100)) return 'th';
  switch (integer % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const ordinalFormat = (number: number): string => number + suffix(number);
